import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
/**
 * @author zhouchangluan
 * @fileoverview 资讯list
 */

import { defineComponent, toRefs, reactive, watch } from "vue";
import _ from "lodash";
// components

export default defineComponent({
  name: "NewsList",
  props: {
    tabData: {
      type: Array,
      required: false,
      default: () => []
    },
    typeActive: {
      type: Number,
      required: false,
      default: 1
    },
    newsData: {
      type: Array,
      required: false,
      default: () => []
    },
    showType: {
      type: Boolean,
      required: false,
      default: true
    },
    isHome: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      tabData,
      typeActive,
      newsData,
      showType
    } = toRefs(props);
    const state = reactive({
      typeActive: typeActive.value,
      tabData: tabData.value || [],
      newsData: newsData.value || []
    });

    // 监听资讯列表变化
    watch(() => props.newsData, val => {
      state.newsData = val;
    });

    // 类型切换
    function typeSwitch(type) {
      state.typeActive = type;
      emit("typeSwitch", {
        value: type
      });
    }

    // 点击资讯item
    function clickItem(item) {
      emit("clickNewsItem", item);
    }
    return () => {
      // 资讯类型切换
      function buildTypeSwitch() {
        const tabItemEle = _.map(state.tabData, (tabItem, index) => {
          // 文本类型
          const tabItemTxt = _createVNode("span", {
            "class": {
              "type-switch": true,
              "active-type": state.typeActive === tabItem.type
            },
            "onClick": () => typeSwitch(tabItem.type)
          }, [tabItem.text]);

          // 图片类型
          const tabItemImg = _createVNode("img", {
            "class": "type-switch-img",
            "src": state.typeActive === tabItem.type ? require(`@/assets/img/${tabItem.actImgUrl}`) : require(`@/assets/img/${tabItem.imgUrl}`),
            "onClick": () => typeSwitch(tabItem.type)
          }, null);

          // 分隔线
          const divideLineEle = tabItem.isImgType ? _createVNode("img", {
            "class": "divide-line-img",
            "src": require(`@/assets/img/${tabItem.divideLine}`)
          }, null) : _createVNode("span", {
            "class": "divide-line-text"
          }, null);
          return _createVNode("div", {
            "class": "type-switch-item"
          }, [tabItem.isImgType ? tabItemImg : tabItemTxt, index !== state.tabData.length - 1 ? divideLineEle : ""]);
        });
        return _createVNode("div", {
          "class": "news-type-switch"
        }, [_createVNode("div", {
          "class": "type-switch-ele"
        }, [tabItemEle])]);
      }

      // 资讯列表展示
      function buildNewsList() {
        const contentItem = _.map(state.newsData, item => {
          return _createVNode("div", {
            "class": "content-item",
            "onClick": () => clickItem(item)
          }, [_createVNode("div", {
            "class": "content-title"
          }, [_createVNode("span", null, [_createTextVNode("\xB7 ")]), _createVNode("span", null, [item.title])]), _createVNode("div", {
            "class": "content-date"
          }, [item.published_time])]);
        });
        return _createVNode("div", {
          "class": "news-content"
        }, [contentItem]);
      }
      return _createVNode("div", {
        "class": "news-list-box"
      }, [showType.value ? buildTypeSwitch() : "", buildNewsList()]);
    };
  }
});